module.exports = __webpack_public_path__ + "static/media/IMG_0899.873682c5.jpg";